export default __webpack_public_path__ + "content/media/9.64e44963.jpg";